<template>
  <div>
    <div class="text-center callOverlay" v-if="$store.state.show.callOverlay">
      <v-overlay :value="$store.state.show.callOverlay">
        <div class="content-center">
          <v-row>
            <v-col
              cols="12"
              style="
                justify-content: center;
                align-items: center;
                display: flex;
              "
            >
              <div class="pulse">
                <v-icon size="45">mdi-phone</v-icon>
              </div>
            </v-col>
            <v-col>
              <br />
              The call in progress please wait.. <br />
              <v-btn class="my-6" color="red" @click="cancelCall">
                <b>cancel</b>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-overlay>
    </div>
    <v-container
      v-show="!$store.state.show.callOverlay"
      full-height
      fluid
      :class="this.$vuetify.breakpoint.xs ? 'mb-10' : 'mb-10 px-5'"
    >
      <v-btn
        fab
        class="close-fullscreen-btn"
        v-if="videoFullscreen"
        @click="videoFullscreen = false"
      >
        <v-icon color="cleed_blue" dark> mdi-window-close </v-icon>
      </v-btn>

      <v-card
        flat
        outlined
        elevation="0"
        height="100%"
        style="border-radius: 1rem"
      >
        <!-- Call Wrapper -->
        <div
          class="call-main-wrapper"
          :style="
            this.$vuetify.breakpoint.xs
              ? 'min-height: 80vh;'
              : 'min-height: 90vh;'
          "
        >
          <div class="call-view">
            <div class="call-window">
              <!-- Call Header -->

              <v-toolbar flat>
                <v-toolbar-title
                  :class="this.$vuetify.breakpoint.xs ? 'mt-2' : 'ma-2'"
                >
                  <div class="user-details">
                    <div class="float-left user-img">
                      <div class="avatar avatar-sm mr-4">
                        <v-icon
                          class=""
                          size="48"
                          dark
                          color="primary darken-5"
                        >
                          mdi-account-circle
                        </v-icon>
                        <span class="status online"></span>
                      </div>
                    </div>
                    <div class="user-info float-left">
                      <span>{{
                        $store.state.chat_user.firstname ||
                        $store.state.chat_user.email ||
                        `#${$store.state.chat_user.id}`
                      }}</span>
                      <span class="last-seen">{{
                        $store.state.online_users.includes(
                          $store.state.chat_user.guid
                        )
                          ? "Online"
                          : "Offline"
                      }}</span>
                    </div>
                  </div>
                </v-toolbar-title>
                <!-- <code>{{ $store.state.chat_user.guid }}</code> -->
                <v-spacer></v-spacer>
                <h4>Live video stream</h4>
                <v-spacer></v-spacer>
                <v-menu
                  left
                  bottom
                  offset-y
                  :close-on-click="true"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-width="300"
                  transition="slide-y-transition"
                  max-height="300"
                  style="z-index: 99"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="ma-3">
                      <v-icon size="30" color="grey lighten-1">mdi-cog</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <ScreenShot
                      :remoteVideoRef="$refs.remoteVideoRef"
                      :permission="permission"
                    />

                    <v-list-group
                      prepend-icon="mdi-camera"
                      append-icon="mdi-menu-swap"
                      :disabled="!permission"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>Cameras</v-list-item-title>
                      </template>

                      <v-list-item
                        dense
                        v-for="device in devices"
                        :key="device.deviceId"
                        link
                        @click="(camera = device.deviceId), replaceStream()"
                      >
                        <v-list-item-title>
                          <h5
                            :class="
                              device.deviceId == camera ? 'primary--text' : ''
                            "
                            style="max-width: 272px"
                          >
                            {{
                              device.label || device.deviceId || device.groupId
                            }}
                          </h5>
                        </v-list-item-title>
                        <v-list-item-icon>
                          <v-icon
                            dark
                            :color="
                              device.deviceId == camera
                                ? 'primary'
                                : 'grey lighten-1'
                            "
                          >
                            mdi-webcam
                          </v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list-group>

                    <v-list-group
                      prepend-icon="mdi-microphone"
                      append-icon="mdi-menu-swap"
                      :disabled="!permission"
                    >
                      <template v-slot:activator>
                        <v-list-item-title>Microphones</v-list-item-title>
                      </template>

                      <v-list-item
                        dense
                        v-for="device in soundDevices"
                        :key="device.deviceId"
                        link
                        @click="(microphone = device.deviceId), replaceStream()"
                      >
                        <v-list-item-title>
                          <h5
                            :class="
                              device.deviceId == microphone
                                ? 'primary--text'
                                : ''
                            "
                            style="max-width: 272px"
                          >
                            {{
                              device.label || device.deviceId || device.groupId
                            }}
                          </h5>
                        </v-list-item-title>
                        <v-list-item-icon>
                          <v-icon
                            dark
                            :color="
                              device.deviceId == microphone
                                ? 'primary'
                                : 'grey lighten-1'
                            "
                          >
                            mdi-microphone
                          </v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </v-menu>
              </v-toolbar>

              <v-divider></v-divider>
              <!-- /Call Header -->

              <!-- Call Contents -->
              <div class="call-contents">
                <div class="call-content-wrap">
                  <v-row
                    no-gutters
                    justify="center"
                    align="center"
                    style="height: 100%"
                  >
                    <v-col cols="auto">
                      <div>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-card
                              flat
                              outlined
                              :class="
                                videoFullscreen
                                  ? 'user-video-fullscreen'
                                  : !this.$vuetify.breakpoint.xs
                                  ? 'user-video'
                                  : ''
                              "
                            >
                              <videoConversation />
                              <v-row
                                justify="start"
                                align="start"
                                class="no-video-absolute mt-2"
                                dense
                              >
                                <v-col cols="auto" class="ml-2">
                                  <v-icon
                                    dark
                                    color="error lighten-2"
                                    size="50"
                                    v-if="!remoteStreamMedia.video"
                                  >
                                    mdi-video-off
                                  </v-icon>
                                </v-col>
                                <v-col cols="auto">
                                  <v-icon
                                    class="mt-1"
                                    dark
                                    color="error lighten-2"
                                    size="45"
                                    v-if="!remoteStreamMedia.audio"
                                  >
                                    mdi-microphone-off
                                  </v-icon>
                                </v-col>

                                <span
                                  v-if="this.timerCount.mins >= 9"
                                  class="end_call"
                                  style="margin-top: 20px"
                                  >Cet appel prendra fin dans moins d'une
                                  minute...</span
                                >
                              </v-row>
                              <video
                                playsinline
                                poster="@/assets/user_call.jpg"
                                ref="remoteVideoRef"
                                id="remoteVideoRef"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <div
                              :class="
                                !this.$vuetify.breakpoint.xs ? 'my-video' : ''
                              "
                              :style="resize()"
                            >
                              <ul style="list-style: none; padding-left: 0px">
                                <li>
                                  <v-card flat outlined :loading="changeCam">
                                    <v-row
                                      justify="end"
                                      align="start"
                                      class="no-video-absolute mt-3"
                                      v-show="!changeCam"
                                      dense
                                    >
                                      <v-col cols="auto" class="ml-2">
                                        <v-icon
                                          dark
                                          color="error lighten-2"
                                          size="50"
                                          v-if="!video"
                                        >
                                          mdi-video-off
                                        </v-icon>
                                      </v-col>
                                      <v-col cols="auto">
                                        <v-icon
                                          class="mt-1"
                                          dark
                                          color="error lighten-2"
                                          size="45"
                                          v-if="!mic"
                                        >
                                          mdi-microphone-off
                                        </v-icon>
                                      </v-col>
                                    </v-row>

                                    <video
                                      id="currentUserVideoRef"
                                      playsinline
                                      class="mt-2"
                                      :class="!permission ? 'video-poster' : ''"
                                      ref="currentUserVideoRef"
                                      poster="@/assets/user_call.jpg"
                                    />
                                  </v-card>
                                </li>
                              </ul>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <!-- Call Contents -->

              <!-- Call Footer -->
              <div class="call-footer">
                <div class="call-icons">
                  <v-row justify="center" align="center" dense>
                    <v-col md="2" sm="2" cols="12">
                      <span
                        class="call-duration"
                        :style="
                          this.$vuetify.breakpoint.xs ? 'font-size: 20px;' : ''
                        "
                      >
                        {{
                          `${
                            timerCount.hour > 0
                              ? this.plz(timerCount.hour) + ":"
                              : ""
                          }${
                            timerCount.mins > 0
                              ? this.plz(timerCount.mins) + ":"
                              : "00:"
                          }${
                            timerCount.secs > 0
                              ? this.plz(timerCount.secs)
                              : "00"
                          }`
                        }}
                      </span>
                    </v-col>
                    <v-col md="8" sm="8" cols="12">
                      <ul class="call-items">
                        <ActionBtns
                          @cameraAction="cameraOnOff"
                          @microphoneAction="muteMicrophone"
                          @fullScreen="fullScreen"
                          @startSharingScreen="startSharingScreen"
                          @stopSharingScreen="stopSharingScreen"
                          :permission="permission"
                          :video="video"
                          :mic="mic"
                          :videoFullscreen="videoFullscreen"
                          :sharingScreen="sharingScreen"
                        />
                      </ul>
                    </v-col>
                    <v-col
                      md="2"
                      sm="2"
                      cols="12"
                      :class="this.$vuetify.breakpoint.xs ? 'mt-2' : ''"
                    >
                      <v-btn
                        dark
                        color="#f06060"
                        rounded
                        class="end-call"
                        :small="this.$vuetify.breakpoint.xs"
                        @click="endCall()"
                      >
                        <v-icon dark>mdi-phone-hangup</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- /Call Footer -->
            </div>
          </div>
        </div>

        <!-- /Call Wrapper -->
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { head } from "lodash";
import videoConversation from "./videoConversation.vue";
import ScreenShot from "./ScreenShot.vue";
import ActionBtns from "./ActionBtns.vue";
import { IS_PRODUCTION } from "@/env";

import store from "@/store";

export default {
  name: "video_chat",
  components: {
    videoConversation,
    ScreenShot,
    ActionBtns,
  },
  data() {
    return {
      IS_PRODUCTION,
      camera: null,
      devices: [],
      soundDevices: [],
      microphone: null,
      deviceId: null,
      video: false,
      permission: false,
      mic: undefined,
      videoFullscreen: false,
      menu: false,
      changeCam: true,
      stream: undefined,
      peerId: "",
      socket: null,
      sharingScreen: false,
      timerCount: {
        hour: 0,
        mins: 0,
        secs: 0,
      },
    };
  },
  computed: {
    myPeer() {
      const data = this.$store.state.videoChat.myPeer;
      return data;
    },
    remoteStreamMedia() {
      const data = this.$store.state.videoChat.remoteStreamMedia;
      return data;
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    microphone: function (id) {
      this.deviceId = id;
    },
  },
  destroyed() {
    console.log("destroyed");
    this.$socket.emit("ADMIN_EndCalling", {
      guid: store.state.chat_user.guid,
      message: "end the call",
    });
    this.closeStream();
  },
  async mounted() {
    await this.getDevices();
    await this.enableVideoStream();
    console.info("permissions : ", this.permission);
    this.countUp();
  },
  async created() {
    console.log("devices cam => ", this.devices);
    console.log("devices mic => ", this.soundDevices);
    let guid = store.state.chat_user.guid;
    this.$store.dispatch("initPeer").then(() => {
      this.myPeer.on("open", (peerId) => {
        this.$socket.emit("create-room", guid, peerId);
        this.peerId = peerId;
      });
    });
  },
  methods: {
    closeStream() {
      let stream = this.stream || window.stream;
      stream.getTracks().forEach((track) => {
        console.log("stop ", { track });
        track.stop();
      });
      stream = null;
      const peerCall = this.$store.state.videoChat.call;
      console.log("destroyed", peerCall);
      if (peerCall) {
        peerCall.close();
      }
    },
    plz(digit) {
      var zpad = digit + "";
      if (digit < 10) {
        zpad = "0" + zpad;
      }
      return zpad;
    },
    countUp() {
      setTimeout(() => {
        var hour, mins, secs;

        hour = this.timerCount.hour;
        mins = this.timerCount.mins;
        secs = this.timerCount.secs;
        secs++;
        if (secs == 60) {
          secs = 0;
          mins = mins + 1;
        }
        if (mins == 60) {
          mins = 0;
          hour = hour + 1;
        }
        if (hour == 13) {
          hour = 1;
        }

        this.timerCount = {
          hour,
          mins,
          secs,
        };
        if (this.timerCount.mins > 9) {
          this.timerCount.mins = 0;
          this.endCall();
        }
        this.countUp();
      }, 1000);
    },
    fullScreen() {
      this.videoFullscreen = !this.videoFullscreen;
    },
    async getDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.devices = devices.filter(
        (device) => device.kind === "videoinput" && device.deviceId
      );
      this.soundDevices = devices.filter(
        (device) => device.kind === "audiooutput" && device.deviceId
      );

      let cameras = head(this.devices);
      if (cameras) {
        this.camera = cameras.deviceId;
      }
      let microphones = head(this.soundDevices);
      if (microphones) {
        this.microphone = microphones.deviceId;
      }
    },
    async replaceStream() {
      if (window.stream) {
        window.stream.getTracks().forEach((track) => {
          track.stop();
          track.enabled = false;
        });
      }
      await this.enableVideoStream();
      let peerConnection = this.$store.state.videoChat.call.peerConnection;
      for (let sender of peerConnection.getSenders()) {
        if (sender.track.kind == "audio") {
          if (this.stream.getAudioTracks().length > 0) {
            sender.replaceTrack(this.stream.getAudioTracks()[0]);
          }
        }
        if (sender.track.kind == "video") {
          if (this.stream.getVideoTracks().length > 0) {
            sender.replaceTrack(this.stream.getVideoTracks()[0]);
          }
        }
      }
    },
    endCall() {
      this.$store.state.show.videoChat = false;
    },
    cancelCall() {
      console.log("cancelCall");
      this.$store.state.show.videoChat = false;
      this.$store.state.show.callOverlay = false;
      this.$store.dispatch("enableCallSound", "stop");
      this.$socket.emit("ADMIN_EndCalling", {
        guid: store.state.chat_user.guid,
        message: "call cancel",
      });
    },
    cameraOnOff() {
      const enabled = this.stream.getVideoTracks()[0].enabled;
      if (enabled) {
        this.stream.getVideoTracks()[0].enabled = false;
        this.video = false;
      } else {
        this.stream.getVideoTracks()[0].enabled = true;
        this.video = true;
      }
      this.$socket.emit("ADMIN_MediaDevicesDtectChange", {
        video: this.video,
        audio: this.mic,
        guid: store.state.chat_user.guid,
      });
    },
    muteMicrophone() {
      const enabled = this.stream.getAudioTracks()[0].enabled;
      console.log(enabled);
      if (enabled) {
        this.stream.getAudioTracks()[0].enabled = false;
        this.mic = false;
      } else {
        this.stream.getAudioTracks()[0].enabled = true;
        this.mic = true;
      }
      this.$socket.emit("ADMIN_MediaDevicesDtectChange", {
        video: this.video,
        audio: this.mic,
        guid: store.state.chat_user.guid,
      });
    },
    async enableVideoStream() {
      this.changeCam = true;
      try {
        console.log("In useUserMedia =>");
        console.log("id device cam => ", this.camera);
        console.log("id device mic => ", this.microphone);
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: this.camera },
          audio: { deviceId: this.microphone },
        });

        window.stream = mediaStream; // make stream available to console
        this.addVideoStream(mediaStream);
        this.stream = mediaStream;
        this.permission = true;
        this.video = true;
        this.mic = true;
        this.changeCam = false;
        this.sharingScreen = false;
      } catch (err) {
        this.permission = false;
        this.video = false;
        this.mic = false;
        this.changeCam = false;
        console.log("err =>", err);
      }
    },
    async addVideoStream(mediaStream) {
      this.$refs.currentUserVideoRef.muted = true;
      this.$refs.currentUserVideoRef.playsinline = true;

      this.$refs.currentUserVideoRef.srcObject = mediaStream;
      this.$refs.currentUserVideoRef.addEventListener("loadedmetadata", () => {
        this.$refs.currentUserVideoRef.play();
      });

      this.myPeer.on("call", (call) => {
        this.$store.state.videoChat.call = call;
        call.answer(mediaStream);
        var remoteRef = this.$refs.remoteVideoRef;
        call.on("stream", function (remoteStream) {
          console.log("on steam", remoteStream);

          remoteRef.srcObject = remoteStream;
          remoteRef.addEventListener("loadedmetadata", () => {
            remoteRef.play();
          });
        });
        call.on("error", (error) => {
          console.log("call on error ", error);
        });
        call.on("close", (err) => {
          console.log("close test here", err);
          this.$store.state.videoChat = {
            call: undefined,
            peerId: undefined,
            myPeer: undefined,
            remoteStreamMedia: {
              audio: true,
              video: true,
            },
            showConversation: false,
            messages: [],
            messageNotif: false,
            socketAddr: undefined,
            RefVideoChatContent: null,
          };
          this.$store.dispatch("setSnackbar", {
            text: "ending the call",
            color: "warning",
            top: true,
            timeout: 1000,
          });
          setTimeout(() => {
            this.$store.state.show.videoChat = false;
          }, 1000);
        });
      });
    },
    stopSharingScreen() {
      let tracks = this.$refs.currentUserVideoRef.srcObject.getTracks();

      tracks.forEach((track) => track.stop());
      this.$refs.currentUserVideoRef.srcObject = null;
      this.sharingScreen = false;
      this.$socket.emit("Admin_SharingScreen", {
        share: this.sharingScreen,
        guid: store.state.chat_user.guid,
      });
      this.replaceStream();
    },
    async startSharingScreen() {
      try {
        this.stream = await navigator.mediaDevices.getDisplayMedia({
          video: {
            cursor: "always",
          },
        });
        if (window.stream) {
          window.stream.getTracks().forEach((track) => {
            track.stop();
            track.enabled = false;
          });
        }
        const audioStream = await navigator.mediaDevices
          .getUserMedia({ audio: true })
          .catch((e) => {
            throw e;
          });
        const audioTrack = audioStream.getAudioTracks()[0];
        this.stream.addTrack(audioTrack); // do stuff
        // or
        // stream = new MediaStream([videoTrack, audioTrack]); // do stuff
        this.$refs.currentUserVideoRef.srcObject = this.stream;
        this.$refs.currentUserVideoRef.addEventListener(
          "loadedmetadata",
          () => {
            this.$refs.currentUserVideoRef.play();
          }
        );
        this.sharingScreen = true;
        this.$socket.emit("Admin_SharingScreen", {
          share: this.sharingScreen,
          guid: store.state.chat_user.guid,
        });
      } catch (err) {
        this.sharingScreen = false;
        this.$socket.emit("Admin_SharingScreen", {
          share: this.sharingScreen,
          guid: store.state.chat_user.guid,
        });
        console.error("Error: " + err);
      }
      let peerConnection = this.$store.state.videoChat.call.peerConnection;
      for (let sender of peerConnection.getSenders()) {
        if (sender.track.kind == "audio") {
          if (this.stream.getAudioTracks().length > 0) {
            sender.replaceTrack(this.stream.getAudioTracks()[0]);
          }
        }
        if (sender.track.kind == "video") {
          if (this.stream.getVideoTracks().length > 0) {
            sender.replaceTrack(this.stream.getVideoTracks()[0]);
          }
        }
      }
    },
    onCapture() {
      console.log("screen shot click", this.$refs.remoteVideoRef.srcObject);
      var canvas = document.createElement("canvas");
      const height = window.innerHeight - 100;
      const width = window.innerWidth - 100;
      canvas.width = width;
      canvas.height = height;
      canvas
        .getContext("2d")
        .drawImage(this.$refs.remoteVideoRef, 0, 0, width, height);
      var data = canvas.toDataURL("image/png");
      var a = document.createElement("a"); //Create <a>
      a.href = data; //Image Base64 Goes here
      a.download = "Image.png"; //File name Here
      a.click(); //Downloaded file
    },
    resize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          console.log("xl");
          return "left: calc(100% - 343px);";
        case "lg":
          console.log("lg");
          return "left: calc(100% - 343px);";
        case "md":
          console.log("md");
          return "left: calc(100% - 300px);";
        case "xs":
          console.log("xs");
          return "";
        case "sm":
          console.log("sm");
          return "";
      }
    },
  },
};
</script>

<style scoped src="../../../assets/videoChat.css"></style>
